<template>
  <article class="info-section">
    <div class="page-section">
      <div class="info-section-header">
        <InfoSectionHeading>{{heading}}</InfoSectionHeading>
      </div>
      <div class="page-content">
        <slot />
      </div>
    </div>
  </article>
</template>

<script>
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'Page',
  props: {
    heading: {
      type: String,
      required: false
    }
  },
  components: {
    InfoSectionHeading
  }
};
</script>

<style>
.page-section {
  max-width: 768px;
  margin: auto;
}
</style>
